console.log('dynamic_profile_form JS application js')
import '@dynamic_profile_form_engine/controllers/index'